import Contracts from './Index.vue';

// Financeiro operacional: administradores, Super Admin ou função com finance_manage.
const FINANCE_ROUTE_META = {
  permissions: ['administrator', 'finance_manage'],
  superAdminOrPermission: true,
};

export const routes = [
  {
    path: 'logistica/fornecedores',
    name: 'talkvia_suppliers',
    meta: FINANCE_ROUTE_META,
    component: () => import('./Suppliers.vue'),
  },
  ...[
    ['contas-a-receber', 'talkvia_receivables'],
    ['contas-a-pagar', 'talkvia_payables'],
    ['conciliacao', 'talkvia_reconciliation'],
  ].map(([path, name]) => ({
    path: `logistica/${path}`,
    name,
    meta: FINANCE_ROUTE_META,
    component: () => import('./Finance.vue'),
  })),
  {
    path: 'contratos',
    name: 'talkvia_contracts',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    component: Contracts,
  },
];
